import encodingDetector from 'encoding-japanese';
// URI Parser from https://stackoverflow.com/a/39308026
export const ParseURI = url => {
    /* eslint-disable */
    let m = url.match(
        /^(([^:\/?#]+:)?(?:\/\/(([^\/?#:]*)(?::([^\/?#:]*))?)))?([^?#]*)(\?[^#]*)?(#.*)?$/
        ),
        r = {
            hash: m[8] || "", // #asd
            host: m[3] || "", // localhost:257
            hostname: m[4] || "", // localhost
            href: m[0] || "", // http://localhost:257/deploy/?asd=asd#asd
            origin: m[1] || "", // http://localhost:257
            pathname: m[6] || (m[1] ? "/" : ""), // /deploy/
            port: m[5] || "", // 257
            protocol: m[2] || "", // http:
            search: m[7] || "" // ?asd=asd
        };
    if (r.protocol.length === 2) {
        r.protocol = "file:///" + r.protocol.toUpperCase();
        r.origin = r.protocol + "//" + r.host;
    }
    r.href = r.origin + r.pathname + r.search + r.hash;
    return m && r;
};

// http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
export function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return `${s4()}-${s4()}-${s4()}`;
}

export function getFileExtension(filename){
    if (typeof filename === 'string'){
        const extension =  filename.split('.').pop();
        return extension === filename ? '' : extension;
    }
    return '';
}

export function getFileEncodingAsync(file){
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
    
        reader.onload = (e) => {
            const codes = new Uint8Array(e.target.result);
            resolve(encodingDetector.detect(codes));
        };
    
        reader.onerror = (e) => {
            reject(e);
        };
    
        reader.readAsArrayBuffer(file);
    })
}

export function encodeBase64File(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onload = () => {
        const fileContent = reader.result;
        try {
          const base64Encoded = btoa(unescape(encodeURIComponent(fileContent)));
          resolve(base64Encoded);
        } catch (err) {
          reject(err);
        }
      };
  
      reader.onerror = reject;
  
      reader.readAsText(file);
    });
  }
  